import { IPhotoUploaderImage } from './MultiplePhotoUploader/multiplePhotoUploaderTypes';
import { Input_core_apimessages_ImageEntry } from '../../gql/graphql';

export const MINIMUM_DIMENSION = 200; // (px) We will prevent images less than this on either side.
const MINIMUM_WARN_DIMENSION = 620; // (px) We will warn them if less than this on either side.

export function meetsMinimumWarnDimension(photo: IPhotoUploaderImage | Input_core_apimessages_ImageEntry) {
  return meetsDimensions(photo, MINIMUM_WARN_DIMENSION);
}

export function meetsMinimumDimension(photo: IPhotoUploaderImage | Input_core_apimessages_ImageEntry) {
  return meetsDimensions(photo, MINIMUM_DIMENSION);
}

function meetsDimensions(photo: IPhotoUploaderImage | Input_core_apimessages_ImageEntry, dimension: number): boolean {
  return photo.width >= dimension && photo.height >= dimension;
}
